import React from 'react';

import { HeroContainer, HeroInternalContainer, HeroImage, HeroDescription, MainText, SmallText } from './styles';

import image from '../../assets/images/HeroImage.svg';
import Button from '../../components/Button';
import { LOW_WHITE, MAIN_BLUE } from '../../styles/Colors';

const Hero = () => {
	const MoveTo = () => {
		window
			.open(
				'https://api.whatsapp.com/send?phone=+5491156011120&text=Hola!%20Me%20gustar%C3%ADa%20consultarte%20sobre%20un%20producto.',
				'_blank',
			)
			.focus();
	};

	return (
		<HeroContainer>
			<HeroInternalContainer>
				<HeroDescription>
					<MainText>
						Asistimos tu <span>RECUPERACIÓN</span>
					</MainText>
					<SmallText>Nuestra misión es ayudarte a mejorar tu calidad de vida.</SmallText>
					<Button
						onClick={MoveTo}
						height={'15%'}
						width={'35%'}
						color={LOW_WHITE}
						background={MAIN_BLUE}
						radius={'20px'}
						value={'Contáctanos'}
					/>
				</HeroDescription>
			</HeroInternalContainer>
		</HeroContainer>
	);
};

export default Hero;
